
export const LOAD_FILTERS_REQUEST = "[FILTERS] LOAD FILTERS REQUEST";
export const LOAD_FILTERS_SUCCESS = "[FILTERS] LOAD FILTERS SUCCESS";
export const LOAD_FILTERS_ERROR = "[FILTERS] LOAD FILTERS ERROR";

export const TOGGLE_FILTER = "[FILTERS] TOGGLE FILTER";

export const DELETE_FILTER = "[FILTERS] DELETE FILTER";

export const RELOAD_DATA = "[FILTERS] RELOAD DATA";

export const TOGGLE_IS_SCORE = "[FILTERS] TOGGLE_IS_SCORE";

export const CLEAN_FILTERS = "[FILTERS] CLEAN FILTERS";
export const LOAD_FILTERS_LIMBO = "[FILTERS] LOAD FILTERS LIMBO";


// WEBPACK FOOTER //
// ./src/modules/filters/filters-action-types.js